import { Grid } from "@mui/material";
import React from "react";
import { FaRegQuestionCircle } from "react-icons/fa";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { RiDatabase2Fill } from "react-icons/ri";
import styles from "./collaboration.module.scss";

const state = [
  {
    id: 1,
    icon: <RiDatabase2Fill />,
    text: "Connect One-to-One With Students",
  },
  {
    id: 2,
    icon: <FaRegQuestionCircle />,
    text: "Select Current International Students or Alumni as UniSearch Mentors",
  },
  {
    id: 3,
    icon: <MdOutlineAdminPanelSettings />,
    text: "Collaborate with UniSearch Counsellors to Guarantee Application Completion and Conversion Success",
  },
];

function RecruiterCard({ item }) {
  return (
    <div className={styles.card_wrapper}>
      <span>{item.icon}</span>
      <p>{item.text}</p>
    </div>
  );
}

export const UniPageDiversifyCollaboration = () => {
  return (
    <section className={styles.section_collaboration}>
      <div className="container">
        <div className={styles.recruit_wrapper}>
          <h2 className={styles.head}>
            Find, Connect to and Convert the Best Prospects Through a Single
            Platform
          </h2>
          <p className={`font-large`}>
            UniSearch is built to enable 360-degree collaboration between your
            university and other stakeholders involved in the process to boost
            successful applications.
          </p>
          <Grid
            container
            spacing={4}
            sx={{ marginTop: "20px" }}
            alignItems="center"
          >
            {state.map((item) => (
              <Grid item md={4} xs={12} key={item.id}>
                <RecruiterCard item={item} />
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </section>
  );
};

export default UniPageDiversifyCollaboration;
